import ViewVotesManager from './Modules/ViewVotes/ViewVotesManager';

class ViewVotes {

    constructor() {
        this.manager = new ViewVotesManager();
        this.applicationTemplate = document.querySelector('.sheet[data-form-type="application"]');
        this.invoiceTemplate = document.querySelector('.sheet[data-form-type="invoice"]');
        this.simpleInvoiceTemplate = document.querySelector('.sheet[data-form-type="simple-invoice"]');

        this.showList();

        window.addEventListener('storage', this.showList.bind(this), false);
    }

    showList() {

        while (document.body.firstElementChild) {
            document.body.removeChild(document.body.firstElementChild);
        }

        this.showApplication();
        this.showInvoice();
        this.showSimpleInvoice();
    }

    showApplication() {
        const items = this.manager.getList('application');
        const length = items.length;

        // 10件ごとに新たな表を生成する。
        const listCount = Math.ceil(length / 10);

        for (let i = 0; i < listCount; i++) {
            const table = this.applicationTemplate.cloneNode(true);
            let until = Math.min(i * 10 + 10, length);
            for (let j = 1; j + i * 10 <= until; j++) {

                const item = items[j + i * 10 - 1];

                table.querySelector(`.ref-num-${j}`).textContent = item.refNum;
                table.querySelector(`.doc-num-${j}`).textContent = item.docNumStr;
                table.querySelector(`.title-${j}`).textContent = item.title;
            }
            document.body.appendChild(table);
        }
    }

    showInvoice() {
        const items = this.manager.getList('invoice');
        const length = items.length;

        // 10件ごとに新たな表を生成する。
        const listCount = Math.ceil(length / 5);

        for (let i = 0; i < listCount; i++) {
            const table = this.invoiceTemplate.cloneNode(true);
            let until = Math.min(i * 5 + 5, length);
            for (let j = 1; j + i * 5 <= until; j++) {

                const item = items[j + i * 5 - 1];

                table.querySelector(`.ref-num-${j}`).textContent = item.refNum;
                table.querySelector(`.doc-num-${j}`).textContent = item.page ? `${item.docNumStr}丁${item.page}` : item.docNumStr;
                table.querySelector(`.title-${j}`).textContent = item.title;
            }
            document.body.appendChild(table);
        }
    }

    showSimpleInvoice() {
        const items = this.manager.getList('simple-invoice');
        const length = items.length;

        // 10件ごとに新たな表を生成する。
        const listCount = Math.ceil(length / 5);

        for (let i = 0; i < listCount; i++) {
            const table = this.simpleInvoiceTemplate.cloneNode(true);
            let until = Math.min(i * 5 + 5, length);
            for (let j = 1; j + i * 5 <= until; j++) {

                const item = items[j + i * 5 - 1];

                table.querySelector(`.ref-num-${j}`).textContent = item.refNum;
                table.querySelector(`.doc-num-${j}`).textContent = item.page ? `${item.docNumStr}丁${item.page}` : item.docNumStr;
                table.querySelector(`.title-${j}`).textContent = item.title;
            }
            document.body.appendChild(table);
        }
    }
}

new ViewVotes();